import React from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { Alert } from "react-bootstrap";
import { useSelector } from "react-redux";
import { ReduxState } from "../../../../redux";
import { TemplateFieldV2 } from "../../../../docuclipper/DocuclipperTypes";

export const withSelectedFragment = (Component) => {
  return ({ field, ...props }: { field: TemplateFieldV2 }) => {
    const { job } = useSelector((state: ReduxState) => state.TemplateField);

    if (field.fragments.loading || (job && job.loading)) {
      return <ClipLoader loading={true} />;
    }

    if (field.fragments.error) {
      return (
        <div style={{ width: "100%" }}>
          <Alert variant="danger">
            {field.fragments.error.split("\n").map((e, i) => (
              <span key={i}>
                {e}
                <br />
              </span>
            ))}
          </Alert>
        </div>
      );
    }

    if (job.error) {
      return (
        <div style={{ width: "100%" }}>
          <Alert variant="danger">
            {job.error.split("\n").map((e, i) => (
              <span key={i}>
                {e}
                <br />
              </span>
            ))}
          </Alert>
        </div>
      );
    }

    const fragments = field.fragments.fragments.filter(
      (f) => f.rectangle.id === field.fragments.selectedFragmentId
    );
    if (fragments.length === 0) {
      return null;
    }
    const fragment = fragments[0];
    return <Component field={field} fragment={fragment.fragment} {...props} />;
  };
};
